import ImagesPallet from "../../../../../../../../utils/ImagesPallet";

const GalleryBostonData = [
  {
    title: 'Cornrow',
    category: 'African Hairstyle',
    image: ImagesPallet.Style1
  },
  {
    title: 'Bob Cut',
    category: 'Modern Style',
    image: ImagesPallet.Style2,
  },
  {
    title: 'Layered Cut',
    category: 'Classic Style',
    image: ImagesPallet.Style3,
  },
  {
    title: 'Pixie Cut',
    category: 'Short Hair',
    image: ImagesPallet.Style4
  },
  {
    title: 'Balayage',
    category: 'Hair Coloring',
    image: ImagesPallet.Style5
  },
  {
    title: 'Japanese Straight',
    category: 'Straight Hair',
    image: ImagesPallet.Style6
  },
  {
    title: 'Japanese Straight',
    category: 'Straight Hair',
    image: ImagesPallet.Style7
  },
  {
    title: 'Japanese Straight',
    category: 'Straight Hair',
    image: ImagesPallet.Style8
  },
  {
    title: 'Japanese Straight',
    category: 'Straight Hair',
    image: ImagesPallet.Style9
  },
];

export default GalleryBostonData;